const LOCALE_BY_LANGUAGE = {
    init: 'es-ES',
    es: 'es-ES',
    en: 'en-GB',
    fr: 'fr-FR',
    de: 'de-DE',
    pt: 'pt-PT',
    it: 'it-IT',
    pl: 'pl-PL',
    cat: 'ca-ES'
}

/**
 * BCP 47 locale for the active app language.
 *
 * @param {string} language
 * @returns {string}
 */
export function localeForLanguage(language) {
    if (!language) {
        return LOCALE_BY_LANGUAGE.es
    }

    return LOCALE_BY_LANGUAGE[language] || language
}

/**
 * Format a measurement with the decimal separator of the active language.
 *
 * @param {number|string|null|undefined} value
 * @param {string} language
 * @param {number} [fractionDigits] Fixed fraction digits. Omit to keep up to 2.
 * @returns {string} Empty string when the value is not numeric.
 */
export function formatDecimal(value, language, fractionDigits) {
    if (value === null || value === undefined || value === '') {
        return ''
    }

    const numeric = typeof value === 'number' ? value : Number(value)
    if (!Number.isFinite(numeric)) {
        return ''
    }

    const options = {}
    if (typeof fractionDigits === 'number') {
        options.minimumFractionDigits = fractionDigits
        options.maximumFractionDigits = fractionDigits
    } else {
        options.maximumFractionDigits = 2
    }

    return new Intl.NumberFormat(localeForLanguage(language), options).format(numeric)
}
